<template>
	<section class="sk-inner-picker">
		<select class="sk-picker-field sk-picker-field-month-2" v-model="month" @change="onChange">
			<option v-for="item in collectionMonth" :key="item.key" :value="item.key">{{ item.name }}</option>
		</select>
		<select class="sk-picker-field sk-picker-field-year-2" v-model="year" @change="onChange">
			<option v-for="item in collectionYear" :key="item.key" :value="item.key">{{ item.name }}</option>
		</select>
	</section>
</template>

<script>
import moment from 'moment'
export default {
	name: 'picker-month',
	data() {
		return {
			year: moment().year(),
			month: moment().month(),
			day: 0,
			hour: 0,
			minute: 0,
		}
	},
	computed: {
		collectionYear() {
			const collection = []

			for (let value = 2000; value < 2100; value++) {
				collection.push({
					key: value,
					name: value
				})
			}

			return collection
		},
		collectionMonth() {
			const collection = []

			for (let value = 0; value < 12; value++) {
				collection.push({
					key: value,
					name: this.getMonth(value)
				})
			}

			return collection
		}
	},
	methods: {
		onChange() {
			this.$emit('change', {
				year: this.year,
				month: this.month + 1,
				day: this.day,
				hour: this.hour,
				minute: this.minute,
			})
		},
		getMonth: (value) => moment().month(value).format('MMM')
	},
	created() {
		this.$emit('change', {
			year: this.year,
			month: this.month + 1,
			day: this.day,
			hour: this.hour,
			minute: this.minute,
		})
	}
}
</script>

<style scope>
.sk-picker-field-month-2 {
	width: 75px;
}
.sk-picker-field-year-2 {
	width: 75px;
}
</style>



// WEBPACK FOOTER //
// src/modules/datetime/PickerMonth.vue